const pageNavigation = document.querySelector('.page-navigation')
const itemsWithUndermenu = pageNavigation.querySelectorAll('.has-undermenu')
const submenuContainer = document.querySelector('.submenu-container')
const submenuLeftSide = submenuContainer.querySelector('.submenu')

const toggleSubmenu = (sourceElement) => {
    const isSame = [...submenuLeftSide.children].some(child =>
        child.isEqualNode(sourceElement),
    )

    if (isSame) {
        submenuLeftSide.innerHTML = ''
    } else {
        submenuLeftSide.innerHTML = ''
        submenuLeftSide.appendChild(sourceElement.cloneNode(true))
    }
}

const initNavigation = () => {
    submenuLeftSide.innerHTML = ''
    for (const item of itemsWithUndermenu) {
        item.addEventListener('click', (e) => {
            e.preventDefault()
            const submenu = e.target.nextElementSibling
            if (submenu) {
                toggleSubmenu(submenu)
            }
        })
    }
}

export { initNavigation }
